module.exports = __webpack_public_path__ + "static/media/mastercard.1d13a168.svg";